import { ICellRendererParams } from "ag-grid-community";
import { BenchmarkOrderType, OrderIntent } from "shared/cubiq-model-multi-asset";
import { SystemConfigPromiseService } from "../../auth-services";
import { OrderType } from "../../cubiq-model-multi-asset/model/enum/OrderType";
import { RequestOrderType } from "../../cubiq-model-multi-asset/model/enum/RequestOrderType";
import { LadderRate } from "./orders/LadderRate";
import { LadderPair } from "./orders/LadderPair";
import { BmarkRiskData } from "shared/cubiq-services/model/benchmarks/BmarkRiskData.model";

export const COLUMN_BASE_DIR: string = "baseClientIntent";
export const COLUMN_BASE_INSTRUMENT: string = "baseInstrument";
export const COLUMN_BASE_ORDER_AMOUNT: string = "baseOrderQty";
export const COLUMN_BASE_ORDER_EXECUTED_AMOUNT: string = "baseExecutedQty";
export const COLUMN_BASE_ORDER_MONITORING_SIDE = "spotBaseTrackColSide";
export const COLUMN_BASE_ORDER_VWAP_ALL_IN: string = "baseVwapAllInRt";
export const COLUMN_BASE_REMAINING_AMOUNT: string = "baseLeavesQty";
export const COLUMN_BASE_SPOT_MARKET_MID: string = "baseSpotMarketMid";
export const COLUMN_BASE_MARKUP: string = "baseMarkup";
export const COLUMN_CLIENT_BRANCH: string = "clientBranchCode";
export const COLUMN_CLIENT_CODE: string = "clientCode";
export const COLUMN_CLIENT_NAME: string = "clientName";
export const COLUMN_ACCOUNT_CODE: string = "accountCode";
export const COLUMN_ACCOUNT_NAME: string = "accountName";

export const COLUMN_CLIENT_ORDER_ID: string = "clOrdID";
export const COLUMN_DEALT_CURRENCY: string = "fixedCode";
export const COLUMN_BASE_CURRENCY: string = "baseCode";

export const COLUMN_DEALT_DIR: string = "clientIntent";
export const COLUMN_DEALT_PERCENTAGE: string = "dealtPercentAway";
export const COLUMN_BASE_PERCENTAGE: string = "basePercentAway";
export const COLUMN_DESK_ID: string = "deskId";
export const COLUMN_TRADER_GROUP_NAMES: string = "traderGroupNames";
export const COLUMN_ENTRY_USER_ID: string = "entryUserId";
export const COLUMN_INSTRUMENT: string = "instrument";
export const COLUMN_ORDER_ACTIVATION_DATE: string = "activationDts";
export const COLUMN_ORDER_AMOUNT: string = "orderQty";
export const COLUMN_ORDER_ASSET_CLASS = "assetClass";
export const COLUMN_ORDER_BASE_TRACKING: string = "baseSpotTracking";
export const COLUMN_ORDER_DEALT_TRACKING: string = "dealtTracking";
export const COLUMN_ORDER_BASE_FWD_PTS: string = "baseFwdPts";
export const COLUMN_ORDER_DEALT_FWD_PTS: string = "dealtFwdPts";

export const COLUMN_ORDER_NDF_BASE_TRACKING: string = "ndfBaseSpotTracking";
export const COLUMN_ORDER_NDF_BASE_FWD_PTS: string = "ndfBaseFwdPts";
export const COLUMN_ORDER_NDF_DEALT_TRACKING: string = "ndfDealtTracking";
export const COLUMN_ORDER_NDF_DEALT_FWD_PTS: string = "ndfDealtFwdPts";

export const COLUMN_ORDER_ID = "orderId";
export const COLUMN_STRATEGY_ID = "strategyId";
export const COLUMN_STP_HOLD = "stpHold";
export const COLUMN_STP_AGG = "stpAggregationEnabled";
export const COLUMN_FWD_ROLL = "autoForwardPricingFg";
export const COLUMN_VOL_PER_MIN = "volumePerMinuteQty";
export const COLUMN_ORDER_FWD_DEALT_TRACKING: string = "dealtFwdTracking";
export const COLUMN_ORDER_FWD_BASE_TRACKING: string = "baseFwdTracking";
export const COLUMN_ORDER_ENTRY_DATE = "entryDts";
export const COLUMN_ORDER_ERRORS: string = "orderErrors";
export const COLUMN_ORDER_EXECUTED_AMOUNT: string = "executedQty";
export const COLUMN_ORDER_EXECUTED_PERC: string = "executedPerc";
export const COLUMN_ORDER_EXECUTED_AMOUNT_USD = "usdEquivExecutedQty";
export const COLUMN_ORDER_EXECUTION_CHANNEL: string = "executionType";
export const COLUMN_ORDER_EXPIRY_DATE: string = "expiryDts";
export const COLUMN_ORDER_MODIFY_DATE = "modifyDts"; // from T_LIMIT_ORDER_REV.UPDATE_STAMP
export const COLUMN_ORDER_MONITORING_SIDE = "trackingSide";
export const COLUMN_ORDER_PRODUCT: string = "product";
export const COLUMN_ORDER_CLIENT_COMMENTS: string = "comments1";
export const COLUMN_ORDER_PRIVATE_COMMENT: string = "comments2";
export const COLUMN_ORDER_REQUEST_RATE: string = "requestRt";
export const COLUMN_ORDER_SIBLING: string = "sibling";
export const COLUMN_ORDER_STATE: string = "orderState";
export const COLUMN_PAUSE_STATE: string = "pauseState";
export const COLUMN_ORDER_SUSPENSION_FROM_DATE: string = "suspensionFromDts";
export const COLUMN_ORDER_SUSPENSION_TO_DATE: string = "suspensionToDts";
export const COLUMN_ORDER_TYPE: string = "requestedOrderType";
export const COLUMN_BASE_ORDER_TYPE: string = "baseOrderType";
export const COLUMN_INVERT_ORDER_TYPE: string = "invertOrderType";
export const COLUMN_ORDER_USD_AMOUNT: string = "usdEquivQty";
export const COLUMN_ORDER_VWAP_ALL_IN: string = "vwapAllInRt";
export const COLUMN_ORDER_VWAP_PTS: string = "avgClientPoints";
export const COLUMN_ORDER_VWAP_SPOT: string = "vwapSpotRt";
export const COLUMN_ORDER_MKT_VWAP_SPOT: string = "marketVwapSpotRt";
export const COLUMN_ORDER_MKT_VWAP_PTS: string = "avgMarketPoints";
export const COLUMN_ORDER_MKT_VWAP_ALL_IN: string = "marketVwapAllInRt";
export const COLUMN_ORDER_FIXING_SOURCE_CODE: string = "fixingSourceCd";
export const COLUMN_BMORDER_FIXING_SOURCE_CODE: string = "bmfixingSourceCd";
export const COLUMN_ORDER_FIXING_DATE: string = "fixingDate";
export const COLUMN_ORDER_STRATEGY_PARAMETERS: string = "strategyParameters";
export const COLUMN_ORDER_PASS_THROUGH_PARAMETERS: string = "passthroughParameters";
export const COLUMN_RATE_SOURCE_CODE: string = "rateSourceCd";
export const COLUMN_REMAINING_AMOUNT: string = "leavesQty";
export const COLUMN_REMAINING_AMOUNT_USD: string = "usdEquivLeavesQty";
export const COLUMN_SALES_GROUP_ID: string = "salesGroupId";
export const COLUMN_SPOT_MARKET_MID: string = "dealtSpotMarketMid";
export const COLUMN_MARKUP: string = "dealtMarkup";
export const COLUMN_INVERT_MARKUP: string = "invertMarkup";
export const COLUMN_TARGET_DESK_ID: string = "targetDeskId";
export const COLUMN_XFER_TARGET_GROUP: string = "xferTargetGroup";
export const COLUMN_TEMPERATURE_VALUE: string = "ordTemp";
export const COLUMN_BASE_TEMPERATURE_VALUE: string = "baseOrdTemp";
export const COLUMN_VALUE_DATE: string = "settleDate";
export const COLUMN_NOTIFICATIONS_VALUE_DATE: string = "notificationSettleDate"; //USED FOR NOTIFICATIONS
export const COLUMN_CLIENT_STP: string = "clientStraightThroughProcessing";
export const COLUMN_CLIENT_TRADER: string = "clientTraderName";
export const COLUMN_AGGREGATION_KEY: string = "aggregationKey";
export const COLUMN_AGGREGATION_ORDERS_ID: string = "aggregationOrdersId";
export const COLUMN_AGGREGATION_PARENT_ID: string = "aggregationParentId";
export const COLUMN_DEALTPERC_AWAY: string = "dealtPercentAway";
export const COLUMN_CANCEL_USER_ID: string = "cancelUserId";
export const COLUMN_CANCEL_DTS: string = "cancelDts";

// LADDDER RELATED COLS
export const COLUMN_LADDER_INSTRUMENT: string = "ladderInstrument";
export const COLUMN_LADDER_DIR: string = "ladderClientIntent";
export const COLUMN_LADDER_CURRENCY: string = "ladderCode";
export const COLUMN_LADDER_ORDER_AMOUNT: string = "ladderOrderQty";
export const COLUMN_LADDER_ORDER_EXECUTED_AMOUNT: string = "ladderExecutedQty";
export const COLUMN_LADDER_REMAINING_AMOUNT: string = "ladderLeavesQty";
export const COLUMN_LADDER_POSITION: string = "position";
export const COLUMN_ORDER_NDF_LADDER_FWD_PTS: string = "ndfLadderFwdPts";
export const COLUMN_ORDER_LADDER_FWD_PTS: string = "ladderFwdPts";
export const COLUMN_ORDER_LADDER_FWD_TRACKING: string = "ladderFwdTracking";
export const COLUMN_LADDER_PERCENTAGE: string = "ladderPercentAway";
export const COLUMN_LADDER_TEMPERATURE_VALUE: string = "ladderOrdTemp";
export const COLUMN_LADDER_ORDER_MONITORING_SIDE = "spotLadderTrackColSide";
export const COLUMN_LADDER_MARKUP = "ladderMarkup";
export const COLUMN_LADDER_ORDER_TYPE: string = "ladderRequestedOrderType";

// HIDDEN Ladder COLS (not all have direct adapter mappings)
export const COLUMN_INVERT_DIR: string = "invertClientIntent";
export const COLUMN_INVERT_INSTRUMENT: string = "invertInstrument";
export const COLUMN_INVERT_CURRENCY: string = "nonBaseCode";
export const COLUMN_INVERT_FWD_TRACKING: string = "invertFwdTracking";
export const COLUMN_INVERT_SPOT_TRACKING: string = "invertSpotTracking";
export const COLUMN_INVERT_FWD_PTS: string = "invertFwdPts";
export const COLUMN_INVERT_AMOUNT: string = "invertOrderQty";
export const COLUMN_INVERT_EXECUTED_AMOUNT: string = "invertExecutedQty";
export const COLUMN_INVERT_REMAINING_AMOUNT: string = "invertLeavesQty";
export const COLUMN_INVERT_NDF_TRACKING: string = "ndfInvertSpotTracking";
export const COLUMN_INVERT_NDF_FWD_PTS: string = "ndfInvertFwdPts";
export const COLUMN_LADDER_BASE_PERCENTAGE: string = "ladderBasePercentAway";

export const COLUMN_INVERT_ORDER_MONITORING_SIDE = "spotInvertTrackColSide";
export const COLUMN_ORDER_TRAILING_TRIGGER = "trailingTrigger";
export const COLUMN_INVERT_PERCENTAGE: string = "invertPercentAway";
export const COLUMN_INVERT_TEMPERATURE_VALUE: string = "invertOrdTemp";

export const COLUMN_ALLOCATION_ID = "allocationId";

export const COLUMN_ALLOC_ID = "allocId";
export const COLUMN_FILL_CLIENT_PTS = "clientFillPts";
export const COLUMN_REQ_FWD_PTS = "reqFwdPoints";
export const COLUMN_FILL_CLIENT_ALLIN = "clientFillAllIn";
export const COLUMN_MARKET_PTS = "marketPts";
export const COLUMN_MARKET_ALLIN = "marketAllIn";
export const COLUMN_VALUE_DT = "valueDt";
export const COLUMN_DEAL_ID = "dealId";

export const REQUESTED_FIXING_TIME_COLUMN_PROPERTY = "reqFixingTime";
export const REQUESTED_FIXING_DATE_COLUMN_PROPERTY = "reqFixingDate";
export const REQUESTED_FIXING_TIMEZONE_COLUMN_PROPERTY = "reqFixingTzCd";
export const FIXING_DATE_COLUMN_PROPERTY = "fixingDate";
export const MOMENT_DATE_FORMAT_STRING = "YYYY-MM-DD HH:mm:ss.SSS";
export const FIXING_DATE_UTC_FORMAT = "HH:mm DD-MMM-YYYY";

export const DATE_FORMAT_SHORT = "DD-MMM-YY";
export const TIME_FORMAT_SHORT = "HH:mm";
export const TIME_ZONE_UTC = "UTC";
export const COLUMN_ORDER_FROM_DATE = "activationDts";
export const COLUMN_ORDER_FROM_DATE_HEADER = "Good From";

export const DEALT_BASE_SWAP_MAP: Map<string, string> = new Map([
  [COLUMN_INSTRUMENT, COLUMN_BASE_INSTRUMENT],
  [COLUMN_DEALT_DIR, COLUMN_BASE_DIR],
  [COLUMN_DEALT_CURRENCY, COLUMN_BASE_CURRENCY],
  [COLUMN_ORDER_AMOUNT, COLUMN_BASE_ORDER_AMOUNT],
  [COLUMN_REMAINING_AMOUNT, COLUMN_BASE_REMAINING_AMOUNT],
  [COLUMN_ORDER_EXECUTED_AMOUNT, COLUMN_BASE_ORDER_EXECUTED_AMOUNT],
  [COLUMN_ORDER_VWAP_ALL_IN, COLUMN_BASE_ORDER_VWAP_ALL_IN],
  [COLUMN_SPOT_MARKET_MID, COLUMN_BASE_SPOT_MARKET_MID],
  [COLUMN_ORDER_MONITORING_SIDE, COLUMN_BASE_ORDER_MONITORING_SIDE],
  [COLUMN_MARKUP, COLUMN_BASE_MARKUP],
  [COLUMN_DEALT_PERCENTAGE, COLUMN_BASE_PERCENTAGE],
  [COLUMN_ORDER_FWD_DEALT_TRACKING, COLUMN_ORDER_FWD_BASE_TRACKING],
  [COLUMN_ORDER_TYPE, COLUMN_BASE_ORDER_TYPE],
]);

export const BASE_DEALT_SWAP_MAP: Map<string, string> = new Map([
  [COLUMN_BASE_INSTRUMENT, COLUMN_INSTRUMENT],
  [COLUMN_BASE_DIR, COLUMN_DEALT_DIR],
  [COLUMN_BASE_CURRENCY, COLUMN_DEALT_CURRENCY],
  [COLUMN_BASE_ORDER_AMOUNT, COLUMN_ORDER_AMOUNT],
  [COLUMN_BASE_REMAINING_AMOUNT, COLUMN_REMAINING_AMOUNT],
  [COLUMN_BASE_ORDER_EXECUTED_AMOUNT, COLUMN_ORDER_EXECUTED_AMOUNT],
  [COLUMN_BASE_ORDER_VWAP_ALL_IN, COLUMN_ORDER_VWAP_ALL_IN],
  [COLUMN_BASE_SPOT_MARKET_MID, COLUMN_SPOT_MARKET_MID],
  [COLUMN_BASE_ORDER_MONITORING_SIDE, COLUMN_ORDER_MONITORING_SIDE],
  [COLUMN_BASE_MARKUP, COLUMN_MARKUP],
  [COLUMN_BASE_PERCENTAGE, COLUMN_DEALT_PERCENTAGE],
  [COLUMN_ORDER_FWD_BASE_TRACKING, COLUMN_ORDER_FWD_DEALT_TRACKING],
  [COLUMN_BASE_ORDER_TYPE, COLUMN_ORDER_TYPE],
]);

export const SPOT_DEALT_BASE_SWAP_MAP = new Map<string, string>([
  [COLUMN_ORDER_DEALT_TRACKING, COLUMN_ORDER_BASE_TRACKING],
  [COLUMN_ORDER_DEALT_FWD_PTS, COLUMN_ORDER_BASE_FWD_PTS],
]);

export const SPOT_BASE_DEALT_SWAP_MAP = new Map<string, string>([
  [COLUMN_ORDER_BASE_TRACKING, COLUMN_ORDER_DEALT_TRACKING],
  [COLUMN_ORDER_BASE_FWD_PTS, COLUMN_ORDER_DEALT_FWD_PTS],
]);

export const NDF_DEALT_BASE_SWAP_MAP: Map<string, string> = new Map([
  [COLUMN_ORDER_NDF_DEALT_TRACKING, COLUMN_ORDER_NDF_BASE_TRACKING],
  [COLUMN_ORDER_NDF_DEALT_FWD_PTS, COLUMN_ORDER_NDF_BASE_FWD_PTS],
]);

export const NDF_BASE_DEALT_SWAP_MAP: Map<string, string> = new Map([
  [COLUMN_ORDER_NDF_BASE_TRACKING, COLUMN_ORDER_NDF_DEALT_TRACKING],
  [COLUMN_ORDER_NDF_BASE_FWD_PTS, COLUMN_ORDER_NDF_DEALT_FWD_PTS],
]);

export const DEALT_NDF_SPOT_TRACKING_SWAP_MAP: Map<string, string> = new Map([
  [COLUMN_ORDER_NDF_DEALT_TRACKING, COLUMN_ORDER_DEALT_TRACKING],
  [COLUMN_ORDER_NDF_DEALT_FWD_PTS, COLUMN_ORDER_DEALT_FWD_PTS],
]);

export const DEALT_SPOT_NDF_TRACKING_SWAP_MAP: Map<string, string> = new Map([
  [COLUMN_ORDER_DEALT_TRACKING, COLUMN_ORDER_NDF_DEALT_TRACKING],
  [COLUMN_ORDER_DEALT_FWD_PTS, COLUMN_ORDER_NDF_DEALT_FWD_PTS],
]);

export const BASE_NDF_SPOT_TRACKING_SWAP_MAP: Map<string, string> = new Map([
  [COLUMN_ORDER_NDF_BASE_TRACKING, COLUMN_ORDER_BASE_TRACKING],
  [COLUMN_ORDER_NDF_BASE_FWD_PTS, COLUMN_ORDER_BASE_FWD_PTS],
]);

export const BASE_SPOT_NDF_TRACKING_SWAP_MAP: Map<string, string> = new Map([
  [COLUMN_ORDER_BASE_TRACKING, COLUMN_ORDER_NDF_BASE_TRACKING],
  [COLUMN_ORDER_BASE_FWD_PTS, COLUMN_ORDER_NDF_BASE_FWD_PTS],
]);

export const ORDER_AGGREGATION_RATE_DATA_COPY_SET: Set<string> = new Set<string>([
  COLUMN_BASE_TEMPERATURE_VALUE,
  COLUMN_INVERT_TEMPERATURE_VALUE,
]);

export const ORDER_AGGREGATION_RATE_FILTER_COPY_SET: Set<string> = new Set<string>(["orderState"]);

export const MARKET_BAR_ORDER_ID_KEY = -1001;

export const RENDERER_ORDER_TYPE_FUNC = (params: ICellRendererParams) => {
  let isSl: boolean = false;

  switch (params.data[params.colDef.field]) {
    case RequestOrderType.SL_ASK:
    case RequestOrderType.SL_ATRATE:
    case RequestOrderType.SL_BID:
    case RequestOrderType.TSL:
    case RequestOrderType.TSL_ASK:
    case RequestOrderType.TSL_BID:
      isSl = true;
      break;
    case RequestOrderType.ALGO:
      isSl = OrderType.LIMIT_SL === params.data?.monitoringOrderType;
      break;
    default:
      isSl = false;
      break;
  }

  let orderType: string = params.value == null ? "" : params.value;

  let positionOrder: boolean =
    params.data != null &&
    ((params.data.fixingDetails != null &&
      params.data.fixingDetails.bmOrderType === BenchmarkOrderType.PositionOrder) ||
      BenchmarkOrderType.PositionOrder === params.data["benchmarkOrderType"]);

  if (RequestOrderType.BMARK == params.data[params.colDef.field] && !positionOrder) {
    orderType = SystemConfigPromiseService.getBenchmarkDisplayName();
  }

  return "<span " + (isSl ? 'class="order-type order-type-sl"' : "") + "> " + orderType + "</span>";
};

export default {};
